import Vue from 'vue';
import Vuex from 'vuex';
import modules from './store';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  getters,
});

export default store;
